import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import faviconUrl from "../../assets/weberwelt_logo.ico";
import faviconIco from "../../assets/favicon.ico";

const useStyles = makeStyles(() => ({
  imageContainer: {
    width: "90%",
    textAlign: "center",
    marginLeft: "5%",
  },
  image: {
    width: "30%",
    padding: "1vw",
    "@media (max-width: 780px)": {
      width: "80%",
      padding: "1vw",
    },
  },
  title: {
    marginLeft: "5%",
    overflowWrap: "break-word",
    "@media (max-width: 780px)": {
      fontSize: "5vw",
    },
  },
  button: {
    marginLeft: "5%",
  },
}));

const serviceList = [
  "Weeding",
  "Mulching",
  "Bush Trimming",
  "Edging",
  "Fertilizing",
  "Cleanup",
  "Other",
];

function PicturesLandscaping() {
  const { storm, address } = useParams();
  const classes = useStyles();

  const cleanAddress = address.replaceAll("_", "").replaceAll(" ", "");
  const [allImages, setAllImages] = useState({});
  const [noWatermark, setNoWatermark] = useState(false);
  const [isLargeWatermark, setIsLargeWatermark] = useState(false);

  useEffect(() => {
    document.title = "Landscaping Photo Dashboard";
    const setFavicon = (faviconUrl) => {
      const favicon = document.querySelector('link[rel="icon"]');
      if (favicon) favicon.href = faviconUrl;
    };
    setFavicon(faviconUrl);

    const fetchImagesForService = async (service) => {
      const base = `/uploads/${storm}/${service}/properties/${cleanAddress}`;

      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append(
        "Authorization",
        "Basic YXBpa2V5OnB1YmxpY19XMTQyaFZYeGc2YVd1NkVZUDRkVVY2QVNQSk5Y"
      );

      const reqOpts = { method: "GET", headers: myHeaders, redirect: "follow" };

      try {
        const res = await fetch(
          `https://api.upload.io/v2/accounts/W142hVX/folders/children?folderPath=${base}`,
          reqOpts
        );
        const data = await res.json();
        const main = data?.children || [];

        const compRes = await fetch(
          `https://api.upload.io/v2/accounts/W142hVX/folders/children?folderPath=${base}/Complaint`,
          reqOpts
        );
        const compData = await compRes.json();
        const complaints = compData?.children || [];

        if (main.length || complaints.length) {
          setAllImages((prev) => ({
            ...prev,
            [service]: { main, complaints },
          }));
        }
      } catch (err) {
        console.log(`Error fetching ${service}:`, err);
      }
    };

    serviceList.forEach(fetchImagesForService);

    return () => setFavicon(faviconIco);
  }, [storm, cleanAddress]);

  const getWatermarkedImage = (file) => {
    let slashes = file.split("/");
    let underscores = slashes[slashes.length - 1].split("_");

    if (underscores.length === 6 && !noWatermark) {
      const [day, month, year, hour, minute] = underscores.map((x) =>
        parseInt(x)
      );
      const d = new Date(Date.UTC(year, month - 1, day, hour, minute));

      const options = {
        timeZone: "America/New_York",
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };

      const estDateString = d.toLocaleString("en-US", options);

      const wm1 = `image=/uploads/templates/blank_bar.png&gravity=bottom-left&layer-opacity=75`;
      const wm2large = `text=${estDateString}&blend=source-atop&color=FF5F1F&font-size=1000&layer-opacity=100&font-weight=900&gravity=bottom-left&padding=25`;
      const wm2small = `text=${estDateString}&blend=source-atop&color=FF5F1F&font-size=200&layer-opacity=100&font-weight=900&gravity=bottom-left&padding=`;

      return `${file.replace("/raw/", "/image/")}?${wm1}&${
        isLargeWatermark ? wm2large : wm2small
      }`;
    }

    return file;
  };

  const hasAnyImages = () => Object.keys(allImages).length > 0;

  const downloadAll = async () => {
    Object.entries(allImages).forEach(([service, { main }]) => {
      main.forEach((img, i) => {
        const filename = `${cleanAddress}_${service}_${i + 1}.jpg`;
        const url = getWatermarkedImage(img.fileUrl);
        const xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.responseType = "blob";
        xhr.onload = function () {
          if (xhr.status === 200) {
            const blob = new Blob([xhr.response], { type: "image/jpeg" });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            link.click();
          }
        };
        xhr.send();
      });
    });
  };

  return (
    <>
      <h1 className={classes.title} style={{ marginTop: "30px" }}>
        {address.replaceAll("_", " ")}
      </h1>
      <h2 className={classes.title}>Event: {storm}</h2>

      {hasAnyImages() && (
        <button className={classes.button} onClick={downloadAll}>
          Download All Images
        </button>
      )}

      <label style={{ paddingLeft: 10 }}>
        <input
          type="checkbox"
          checked={noWatermark}
          onChange={() => setNoWatermark(!noWatermark)}
        />
        No Watermark
      </label>

      {!noWatermark && (
        <label style={{ paddingLeft: 10 }}>
          <input
            type="checkbox"
            checked={isLargeWatermark}
            onChange={() => setIsLargeWatermark(!isLargeWatermark)}
          />
          Large Watermark
        </label>
      )}

      {serviceList.map((service) => {
        const entry = allImages[service];
        if (!entry) return null;

        return (
          <div key={service}>
            <h2 className={classes.title}>{service} Photos</h2>
            <div className={classes.imageContainer}>
              {entry.main.map((img, idx) => (
                <img
                  key={idx}
                  className={classes.image}
                  src={getWatermarkedImage(img.fileUrl)}
                  alt={`${service} ${idx + 1}`}
                />
              ))}
            </div>

            {entry.complaints.length > 0 && (
              <>
                <h3 className={classes.title}>Complaint Follow-Up</h3>
                <div className={classes.imageContainer}>
                  {entry.complaints.map((img, idx) => (
                    <img
                      key={idx}
                      className={classes.image}
                      src={img.fileUrl}
                      alt={`${service} complaint ${idx + 1}`}
                    />
                  ))}
                </div>
              </>
            )}
          </div>
        );
      })}

      {!hasAnyImages() && (
        <h2 className={classes.title}>
          No landscaping photos found for this address.
        </h2>
      )}
    </>
  );
}

export default PicturesLandscaping;
